<script setup>

</script>
<template>
  <h1>Welcome to the home page</h1>
</template>